<div *ngIf="users && users.length > 0" class="page-container">
  <div class="page-title">Users</div>
  <div class="data-table users-table" *ngIf="users.length > 0">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div>
      <select class="user-role-select filter-select" (change)="setFilter($event)" title="Filter by Role">
        <option value="">All Roles</option>
        <option *ngFor="let roleId of userRoleKeys" [value]="roleId">{{UserRole[roleId]}}</option>
      </select>
    </div>
    <div></div>
    <div class="header">First Name</div>
    <div class="header">Last Name</div>
    <div class="header">Email</div>
    <div class="header">Last Login</div>
    <div class="header">Role</div>
    <div class="header">Disabled</div>
    <ng-container *ngFor="let user of filteredUsers">
      <div>{{user.firstName}}</div>
      <div>{{user.lastName}}</div>
      <div>{{user.email}}</div>
      <div>{{user.lastLogin ? (user.lastLogin | date:'MMM d, y h:mm a') : ''}}</div>
      <div>{{UserRole[user.role]}}</div>
      <div>
        <input type="checkbox" class="disabled-checkbox" title="Disable user"
               [checked]="user.disabled === true"
               (change)="toggleDisabled($event, user)" />
      </div>
    </ng-container>
  </div>
</div>

<app-dialog [(visible)]="showUnauthorized">
  <div>Unauthorized</div>
</app-dialog>
